import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { AllApplicantsService } from '../applicants/applicants.service';
import { ProgrammeSelectionService } from './programme-selection.service';
import { Programme } from '../applicant/programme';
import { AcademicYear } from '../applicants/AcademicYear';
import { CommonService } from '../common/common.services';
import { ProgrammeType } from '../common/programmeType';
import { AcceptedApplicantsService } from './accepted-applicants.service';
import { Applicants } from '../applicants/Applicants';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { Router } from '@angular/router';
import { MatSort, Sort } from '@angular/material/sort';
// import * as saveAs from 'file-saver';
// @ts-ignore
import saveAs from 'file-saver';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-accepted-applicants',
  templateUrl: './accepted-applicants.component.html',
  styleUrls: ['./accepted-applicants.component.scss'],
})
export class AcceptedApplicantsComponent implements OnInit {
  @ViewChild('paginator') paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  isHandset$: Observable<boolean> = this.breakpointObserver
    .observe(Breakpoints.Handset)
    .pipe(
      map((result) => result.matches),
      shareReplay(),
    );
  displayedColumns: string[] = [
    'id',
    'Applicant',
    'ProgrammeType',
    'RegistrationNumber',
    'Country',
    'Hometown',
    'Sex',
    'Date',
    'Semester',
    'Status'
  ];

  dataSource: MatTableDataSource<Applicants>;

  year: string;
  programmeTypeId: string;
  programmeId: string;
  years: AcademicYear[];
  programmeTypeList: ProgrammeType[];
  programmeList: Programme[];
  acceptedApplicantList: Applicants[];
  totalApplicants: number;
  totalCertificateApplicants: number;
  totalDegreeApplicants: number;
  totalDiplomaApplicants: number;
  degreeApplicants: Applicants[];
  diplomaApplicants: Applicants[];
  certificateApplicants: Applicants[];
  sortedApplicantList: Applicants[];
  unSortedApplicantList: Applicants[];

  public loading = false;
  constructor(
    private router: Router,
    private commonService: CommonService,
    private programmeSelectionService: ProgrammeSelectionService,
    private allApplicantsService: AllApplicantsService,
    private breakpointObserver: BreakpointObserver,
    private acceptedApplicantsService: AcceptedApplicantsService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.loading = true;
    this.allApplicantsService.getCurrentYear().subscribe((currentYear) => {
      console.log(currentYear.response);
      this.allApplicantsService.getAcademicYears().subscribe((response) => {
        this.years = response;
        this.year = currentYear.response;
        this.programmeSelectionService
          .getProgrammeList()
          .subscribe((programmeList) => {
            this.programmeList = programmeList;
          });
        this.commonService
          .getProgrammeTypes()
          .subscribe((programmeTypeList) => {
            this.programmeTypeList = programmeTypeList;
          });
        setTimeout(()=>{
          this.loading = false;
          this.fetchApplicantList();
        },3000)
      });
    });
  }

  fetchApplicantList() {
    this.allApplicantsService
      .getAllApplicants(this.year)
      .subscribe((response) => {
        this.acceptedApplicantList = response.filter(
          (applicant) => applicant.status === 'ACCEPTED',
        );
        this.dataSource = new MatTableDataSource(this.acceptedApplicantList);
        this.totalApplicants = this.acceptedApplicantList.length;

        this.totalDiplomaApplicants = this.acceptedApplicantList.filter(
          (applicant) => applicant.programmeType.indexOf('Diploma') !== -1,
        ).length;
        this.totalDegreeApplicants = this.acceptedApplicantList.filter(
          (applicant) => applicant.programmeType.indexOf('Bachelor') !== -1,
        ).length;
        this.totalCertificateApplicants = this.acceptedApplicantList.filter(
          (applicant) => applicant.programmeType.indexOf('Certificate') !== -1,
        ).length;
      });
  }


  populateApplicants(type: string): void {
    console.log('displaying data for: ' + type);
  
    switch (type) {
      case 'All':
        // show all applicants
        this.unSortedApplicantList = this.acceptedApplicantList;
        break;
      case 'Bachelor':
        // show Degree applicants
        this.unSortedApplicantList = this.acceptedApplicantList.filter(
          (applicant) => applicant.programmeType.includes('Bachelor')
        );
        break;
      case 'Diploma':
        // show diploma
        this.unSortedApplicantList = this.acceptedApplicantList.filter(
          (applicant) => applicant.programmeType.includes('Diploma')
        );
        break;
      case 'Certificate':
        // show certificates
        this.unSortedApplicantList = this.acceptedApplicantList.filter(
          (applicant) => applicant.programmeType.includes('Certificate')
        );
        break;
      default:
        // Handle unexpected types or default to displaying all applicants
        this.unSortedApplicantList = this.acceptedApplicantList;
        break;
    }
  
    // Update the MatTableDataSource and associated components
    this.dataSource.data = this.unSortedApplicantList;
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.cdr.detectChanges(); // triggers
  }
  



  fetchApplicantTypeListForYear(year: string) {
    this.year = year;
    this.fetchApplicantList();
    this.fetchAcceptedApplicants(
      this.year,
      this.programmeTypeId,
      this.programmeId,
    );
  }

  fetchApplicantTypeListForProgrammeId(programmeId: string) {
    this.programmeId = programmeId;
    this.fetchApplicantList();
    this.fetchAcceptedApplicants(
      this.year,
      this.programmeTypeId,
      this.programmeId,
    );
  }

  fetchApplicantTypeListForProgrammeTypeId(programmeTypeId: string) {
    this.programmeTypeId = programmeTypeId;
    this.fetchApplicantList();
    this.fetchAcceptedApplicants(
      this.year,
      this.programmeTypeId,
      this.programmeId,
    );
  }

  fetchAcceptedApplicants(
    year: string,
    programmeTypeId: string,
    programmeId: string,
  ) {
    if (
      year !== undefined &&
      programmeTypeId !== undefined &&
      programmeId !== undefined
    ) {
      this.acceptedApplicantsService
        .getAcceptedApplicantList(year, programmeId, programmeTypeId)
        .subscribe((applicants) => {
          this.acceptedApplicantList = applicants;
          this.unSortedApplicantList = this.acceptedApplicantList;
          this.dataSource = new MatTableDataSource(this.unSortedApplicantList);
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
        });
    } else if (
      year !== undefined &&
      programmeTypeId === undefined &&
      programmeId === undefined
    ) {
      this.allApplicantsService
        .getAllApplicants(this.year)
        .subscribe((response) => {
          this.acceptedApplicantList = response.filter(
            (applicant) => applicant.status === 'ACCEPTED',
          );
          this.dataSource = new MatTableDataSource(this.acceptedApplicantList);
          this.dataSource.paginator = this.paginator;
        });
    }
  }

  goToApplicantDetails(applicantId: string) {
    this.router.navigateByUrl(
      '/applicant?applicantId=' + applicantId + '&year=' + this.year,
    );
  }

  sortData(sort: Sort) {
    this.sortedApplicantList = this.acceptedApplicantList.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'id':
          return this.commonService.compare(a.personId, b.personId, isAsc);
        case 'Applicant':
          return this.commonService.compare(
            a.applicantName,
            b.applicantName,
            isAsc,
          );
        case 'ProgrammeType':
          return this.commonService.compare(
            a.programmeType,
            b.programmeType,
            isAsc,
          );
        case 'ProgrammeTitle':
          return this.commonService.compare(a.programme, b.programme, isAsc);
        case 'Country':
          return this.commonService.compare(a.country, b.country, isAsc);
        case 'City':
          return this.commonService.compare(a.hometown, b.hometown, isAsc);
        case 'Sex':
          return this.commonService.compare(a.gender, b.gender, isAsc);
        case 'Status':
          return this.commonService.compare(a.status, b.status, isAsc);
        default:
          return 0;
      }
    });

    this.dataSource = new MatTableDataSource(this.sortedApplicantList);
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  get filteredRowCount(): number {
    return this.dataSource ? this.dataSource.filteredData.length : 0;
  }
  
  downloadExcelFile() {
    this.allApplicantsService
      .getAllAcceptedApplicantsExcelFile(this.year)
      .subscribe((blob) => {
        saveAs(blob, 'AUCDT Accepted Applicants.xlsx');
      });
  }

  exportExcel(): void {
    const data: any[] = this.unSortedApplicantList;
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
    const workbook: XLSX.WorkBook = { Sheets: {'AUCDT_Accepted_Applicants':worksheet}, SheetNames: ['AUCDT_Accepted_Applicants'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, 'AUCDT_Accepted_Applicants');
  }
  
  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: 'application/octet-stream' });
    const a: HTMLAnchorElement = document.createElement('a');
    document.body.appendChild(a);
    a.href = URL.createObjectURL(data);
    a.download = `${fileName}.xlsx`;
    a.click();
  }
}
